/** Waterfall steps (D529): from a starting figure through increases and decreases to a total (e.g. gross revenue → net). */
import { isFiniteNumber } from './numbers.js';
/** Compute the bars of a waterfall. A missing `delta` counts as 0. */
export function waterfallSteps(inputs) {
    let running = 0;
    let moved = false;
    const steps = [];
    for (const item of inputs) {
        const value = isFiniteNumber(item.value) ? item.value : null;
        if (item.kind === 'total') {
            const end = value ?? running;
            steps.push({ key: item.key, label: item.label, kind: 'total', start: 0, end, delta: end, direction: 'total', reconciles: value === null || !moved || value === running });
            running = end;
            moved = false;
        }
        else {
            const delta = value ?? 0;
            const end = running + delta;
            steps.push({ key: item.key, label: item.label, kind: 'delta', start: running, end, delta, direction: delta < 0 ? 'down' : 'up', reconciles: true });
            running = end;
            moved = true;
        }
    }
    const edges = steps.flatMap((s) => [s.start, s.end]);
    return { steps, min: Math.min(0, ...edges), max: Math.max(0, ...edges) };
}
//# sourceMappingURL=waterfall.js.map